<div class='container-fluid simple-layout-container'>
  <router-outlet></router-outlet>
</div>

